import { InputNumber } from "antd";
import styled from "styled-components";

export const StyledCounter = styled.div`
    display: flex;
    width: 40%;
    height: 40px;
`;

const StyledCounterControl = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.collapseHeaderBackground};
    border: 1px solid #313131;
    color: ${({ theme }) => theme.primaryTypographyColor};
    cursor: pointer;
    width: 70px;
    border-radius: 6px 0 0 6px;

    &:disabled {
        opacity: 0.5;
    }
`;

export const StyledCounterDecrement = styled(StyledCounterControl)`
    border-radius: 6px 0 0 6px;
`;

export const StyledCounterIncrement = styled(StyledCounterControl)`
    border-radius: 0 6px 6px 0;
`;

export const StyledNumberInput = styled(InputNumber)`
    border-radius: 0;
    max-width: 65px;
    min-width: 65px;
    background-color: ${(props) =>
        props.theme.collapseHeaderBackground} !important;

    input {
        text-align: center !important;
    }
`;
